var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition-expand", [
    _vm.isListExpanded
      ? _c(
          "ul",
          { staticClass: "products-item-matching-list" },
          _vm._l(_vm.attributeMatches, function (attributeMatch, index) {
            return _c("attribute-matching-list-item", {
              key: index,
              attrs: { "attribute-match": attributeMatch },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }